









import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonInspectResult from "@/components/common/button/ButtonInspectResult.vue";

@Component({
  components: {
    appButtonInspectResult: ButtonInspectResult
  }
})
export default class TopBarTitle extends Vue {
  @Prop() titleText: string;
  @Prop() isEdit: boolean;
  @Prop() addClass: any;
  @Prop({ default: false }) disabled: boolean;
  editBtn: boolean = false;

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    this.checkButtonStatusResult(to.name);
  }

  created() {
    this.checkButtonStatusResult(this.$route.name);
  }

  checkButtonStatusResult(route: any) {
    console.log("TopBarTitle.checkButtonStatusResult route => ", route);
    if (route == "userlegal56" || route == "userrecommend" || route == "inspectioncost" || route == "discountcoupon" || route == "quickmitsumori" || route == "option" || route == "estimate") {
      this.editBtn = true;
    } else {
      this.editBtn = false;
    }
  }

  onEdit() {
    const isEdit = !this.isEdit;
    this.$emit("onEditPrice", isEdit);
  }
}
